import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { differenceInDaysFromTo } from '@/modules/date/helpers';

type Props = {
  activeDate?: string;
  className?: string;
  sold?: number;
};

const BUCKET_TO_TRANSLATION_KEY = {
  active_today: 'TrustActiveToday',
  active_this_week: 'TrustActiveThisWeek',
  active_weeks_ago: 'TrustActiveWeeksAgo',
} as const;

export function TrustSignals({ activeDate, sold, className = '' }: Props) {
  const t = useTranslations('common');

  function getActiveStatus() {
    if (!activeDate) {
      return null;
    }

    if (Object.hasOwn(BUCKET_TO_TRANSLATION_KEY, activeDate)) {
      return t(
        BUCKET_TO_TRANSLATION_KEY[
          activeDate as keyof typeof BUCKET_TO_TRANSLATION_KEY
        ]
      );
    }

    // TODO: Legacy timestamp path — remove after backend is fully rolled out.
    const dateCompare = differenceInDaysFromTo({ from: activeDate });

    if (dateCompare <= 0) {
      return t('TrustActiveToday');
    }
    if (dateCompare <= 7) {
      return t('TrustActiveThisWeek');
    }
    if (dateCompare <= 27) {
      return t('TrustActiveWeeksAgo');
    }
    return null;
  }

  const activeStatus = getActiveStatus();
  const hasSoldItems = sold ? sold > 5 : false;
  const showSeparator = hasSoldItems && activeStatus;

  if (!hasSoldItems && !activeStatus) {
    return null;
  }

  return (
    <div className={`${styles.container} ${className}`}>
      {hasSoldItems && (
        <div className={styles.signal}>
          <Caption variant="lg-regular">
            {t('TrustItemsSold', { sold: sold as number })}
          </Caption>
        </div>
      )}
      {showSeparator && (
        <span className={styles.visualSeparator} aria-hidden="true">
          ·
        </span>
      )}
      {activeStatus && (
        <div className={styles.signal}>
          <Caption variant="lg-regular">{activeStatus}</Caption>
        </div>
      )}
    </div>
  );
}
